"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/**
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @coreapi
 * @preferred
 * @module transition
 */ /** for typedoc */
__export(require("./interface"));
__export(require("./hookBuilder"));
__export(require("./hookRegistry"));
__export(require("./rejectFactory"));
__export(require("./transition"));
__export(require("./transitionHook"));
__export(require("./transitionEventType"));
__export(require("./transitionService"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ui-router-core/lib/transition/index.js
// module id = 355
// module chunks = 1